import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Switch, Route, Redirect} from 'react-router-dom';
import {ConnectedRouter} from 'connected-react-router';
import history from './history';
import {EnvService} from '../services';
import ThemeSwitcher from 'react-css-vars';

import {isAuthenticated} from './auth';

import {
  InitialRegistration,
  DataRegistration,
  EndDataRegistration,
  PhotoTime,
  DocumentTime,
  DataResidential,
  DataDocument,
  CodeExpired,
  DataProfessional,
  IntermediateReturn,
  SignatureExample,
  Signature,
  YourCard,
  DataContact,
  ConfirmationPhotoDocument,
  LinkResendedSucess,
  ProposalSendSucess,
  SignatureNotFound,
  TakeYourPicture,
  ConfirmYourPicture,
  TermsAccept,
  Finish,
  DocumentVerse,
  ValidationAccessCode,
  TakePictureDocument,
  ConfirmPhoneSuccess,
  ValidateCodeSms,
  ProcessingPreEvaluation,
  PreEvaluationCompletedSuccess,
  PreEvaluationCompletedFail,
  RemakePreEvaluation,
  HireInsurance,
  AdditionalCard,
} from '../screens';

import {RouteKeys} from '../constants';

const PrivateRoute = ({component: Component, chave, ...rest}) => (
  <Route
    {...rest}
    render={(props) => {
      if (props.history.action && props.history.action === 'POP') {
        return <Redirect to={{pathname: '/', state: {from: props.location}}} />;
      }

      if (
        !isAuthenticated(chave) &&
        props.location.pathname !== RouteKeys.CodeExpired.value &&
        props.location.pathname !== RouteKeys.ProposalSendSucess.value
      ) {
        return <Redirect to={{pathname: '/', state: {from: props.location}}} />;
      }

      return <Component {...props} />;
    }}
  />
);

class Routes extends Component {
  state = {
    reduxLoaded: false,
  };

  componentDidMount = () => {
    if (EnvService.get('ENV') !== 'dev') {
      console.log = console.warn = console.error = () => {};
    }
  };

  fillReduxFromStorage = () => {};

  render = () => (
    <ConnectedRouter history={history}>
      <Switch>
        <ThemeSwitcher theme={this.props.primario}>
          <PrivateRoute
            exact
            chave={this.props.chave}
            path={RouteKeys.DataRegistration.value}
            component={DataRegistration}
          />
          <PrivateRoute
            exact
            chave={this.props.chave}
            path={RouteKeys.InitialRegistration.value}
            component={InitialRegistration}
          />
          <PrivateRoute
            exact
            chave={this.props.chave}
            path={RouteKeys.EndDataRegistration.value}
            component={EndDataRegistration}
          />
          <PrivateRoute
            exact
            chave={this.props.chave}
            path={RouteKeys.PhotoTime.value}
            component={PhotoTime}
          />
          <PrivateRoute
            exact
            chave={this.props.chave}
            path={RouteKeys.DocumentTime.value}
            component={DocumentTime}
          />
          <PrivateRoute
            exact
            chave={this.props.chave}
            path={RouteKeys.DocumentVerse.value}
            component={DocumentVerse}
          />
          <PrivateRoute
            exact
            chave={this.props.chave}
            path={RouteKeys.DataResidential.value}
            component={DataResidential}
          />
          <PrivateRoute
            exact
            chave={this.props.chave}
            path={RouteKeys.DataDocument.value}
            component={DataDocument}
          />
          <PrivateRoute
            exact
            chave={this.props.chave}
            path={RouteKeys.DataProfessional.value}
            component={DataProfessional}
          />
          <PrivateRoute
            exact
            chave={this.props.chave}
            path={RouteKeys.CodeExpired.value}
            component={CodeExpired}
          />
          <PrivateRoute
            exact
            chave={this.props.chave}
            path={RouteKeys.IntermediateReturn.value}
            component={IntermediateReturn}
          />
          <PrivateRoute
            exact
            chave={this.props.chave}
            path={RouteKeys.SignatureExample.value}
            component={SignatureExample}
          />
          <PrivateRoute
            exact
            chave={this.props.chave}
            path={RouteKeys.Signature.value}
            component={Signature}
          />
          <PrivateRoute
            exact
            chave={this.props.chave}
            path={RouteKeys.YourCard.value}
            component={YourCard}
          />
          <PrivateRoute
            exact
            chave={this.props.chave}
            path={RouteKeys.DataContact.value}
            component={DataContact}
          />
          <PrivateRoute
            exact
            chave={this.props.chave}
            path={RouteKeys.SignatureNotFound.value}
            component={SignatureNotFound}
          />
          <PrivateRoute
            exact
            chave={this.props.chave}
            path={RouteKeys.LinkResendedSucess.value}
            component={LinkResendedSucess}
          />
          <PrivateRoute
            exact
            chave={this.props.chave}
            path={RouteKeys.ProposalSendSucess.value}
            component={ProposalSendSucess}
          />
          <PrivateRoute
            exact
            chave={this.props.chave}
            path={RouteKeys.TakeYourPicture.value}
            component={TakeYourPicture}
          />
          <PrivateRoute
            exact
            chave={this.props.chave}
            path={RouteKeys.ConfirmYourPicture.value}
            component={ConfirmYourPicture}
          />
          <PrivateRoute
            exact
            chave={this.props.chave}
            path={RouteKeys.TermsAccept.value}
            component={TermsAccept}
          />
          <PrivateRoute
            exact
            chave={this.props.chave}
            path={RouteKeys.Finish.value}
            component={Finish}
          />
          <PrivateRoute
            exact
            chave={this.props.chave}
            path={RouteKeys.ValidationAccessCode.value}
            component={ValidationAccessCode}
          />
          <PrivateRoute
            exact
            chave={this.props.chave}
            path={RouteKeys.TakeYourPictureDocument.value}
            component={() => <TakePictureDocument verso={false} />}
          />
          <PrivateRoute
            exact
            chave={this.props.chave}
            path={RouteKeys.TakeYourPictureDocumentBack.value}
            component={() => <TakePictureDocument verso={true} />}
          />
          <PrivateRoute
            exact
            chave={this.props.chave}
            path={RouteKeys.ConfirmationPhotoDocument.value}
            component={() => <ConfirmationPhotoDocument verso={false} />}
          />
          <PrivateRoute
            exact
            chave={this.props.chave}
            path={RouteKeys.ConfirmationPhotoDocumentBack.value}
            component={() => <ConfirmationPhotoDocument verso={true} />}
          />
          <PrivateRoute
            exact
            chave={this.props.chave}
            path={RouteKeys.ValidateCodeSms.value}
            component={ValidateCodeSms}
          />
          <PrivateRoute
            exact
            chave={this.props.chave}
            path={RouteKeys.ConfirmPhoneSuccess.value}
            component={ConfirmPhoneSuccess}
          />
          <PrivateRoute
            exact
            chave={this.props.chave}
            path={RouteKeys.ProcessingPreEvaluation.value}
            component={ProcessingPreEvaluation}
          />
          <PrivateRoute
            exact
            chave={this.props.chave}
            path={RouteKeys.PreEvaluationCompletedSuccess.value}
            component={PreEvaluationCompletedSuccess}
          />
          <PrivateRoute
            exact
            chave={this.props.chave}
            path={RouteKeys.PreEvaluationCompletedFail.value}
            component={PreEvaluationCompletedFail}
          />
          <PrivateRoute
            exact
            chave={this.props.chave}
            path={RouteKeys.RemakePreEvaluation.value}
            component={RemakePreEvaluation}
          />
          <PrivateRoute
            exact
            chave={this.props.chave}
            path={RouteKeys.HireInsurance.value}
            component={HireInsurance}
          />
          <PrivateRoute
            exact
            chave={this.props.chave}
            path={RouteKeys.AdditionalCard.value}
            component={AdditionalCard}
          />

          <Route exact path="/" component={ValidationAccessCode} />
        </ThemeSwitcher>
      </Switch>
    </ConnectedRouter>
  );
}

const mapStateToProps = ({customer, theme}) => {
  const {chave} = customer;
  const {primario} = theme;
  return {chave, primario};
};

export default connect(mapStateToProps, {})(Routes);
